const sliceString = (string) => {
    if(string.length > 25){
        let slicedString= string.slice(0,25);
        return slicedString + "...";
    } else {
        return string
    }
}

export { sliceString }